require('/opt/odin/app/frontend/components/new_button_share/index.module.scss');module.exports = "../../app/cells/components/new_button_share/show.erb";